module.exports = __webpack_public_path__ + "img/tree_right_1.001470da.png";